<div
  class="notice-panel"
  (mouseenter)="pause()"
  (mouseleave)="resume()"
>

  <div class="notice-header"   [ngStyle]="{
    'background': newsHeaderBackground,
    'color': newsHeaderColor
  }">
    {{ newsHeaderText }}
  </div>

  <div class="notice-body">

    <div
      class="notice-slider"
      [style.transform]="transformValue"
      [style.transition]="sliderTransition ? 'transform .8s ease' : 'none'"
    >

      <div
        class="notice-item"
        *ngFor="let item of displayList" (click)="goToFullNews(item)"
      >
        <div class="date-badge">
          {{ item.date }}
        </div>

        <div class="notice-title">
          {{ item.title }}

          <span
            *ngIf="item.isNew"
            class="new-tag"
          >
            NEW
          </span>
        </div>
      </div>

    </div>

  </div>

  <div class="notice-footer">
    <button
      class="view-all-btn"
      (click)="viewAll()"
    >
      View All
    </button>
  </div>

</div>